export default __webpack_public_path__ + "static/digilock-showroom-chicago-ab0da33d598459abd0a4c22ec382424c.jpg";